import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lottie from "lottie-react";
import Thinking from "assets/images/Thinking.json";

const LoadingModal = ({ isOpen, loadingTexts = [], intervalTime = 2000 }) => {
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    if (!isOpen || loadingTexts.length === 0) return;

    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % loadingTexts.length);
    }, intervalTime);

    return () => clearInterval(interval);
  }, [isOpen, loadingTexts, intervalTime]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="w-full h-full flex items-center justify-center bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            className="rounded-2xl p-10 w-[100%] max-w-md text-center "
          >
            <div className="mb-2 flex justify-center">
              <Lottie
                animationData={Thinking}
                style={{ width: 40, height: 60 }}
              />
            </div>
            <motion.p
              key={textIndex}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
              className="text-sm font-medium text-gray-700"
            >
              {loadingTexts[textIndex]}
            </motion.p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default LoadingModal;
